import { render, staticRenderFns } from "./debug.vue?vue&type=template&id=66a7a4ae"
import script from "./debug.vue?vue&type=script&lang=ts"
export * from "./debug.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports